import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export const userTagsQueryKey = 'user-tags';

export function useUserTags(userId: string) {
    return useQuery({
        queryKey: [userTagsQueryKey, userId],
        queryFn: () => sdClient.getUserTags({ userId }),
    });
}
